// extracted by mini-css-extract-plugin
export var container = "input-module--container--BoOrx";
export var hasIcon = "input-module--has-icon--B3nVV";
export var icon = "input-module--icon--mLopF";
export var iconBox = "input-module--icon-box--jAkVU";
export var input = "input-module--input--Oxdkk";
export var inputBox = "input-module--input-box--5COWH";
export var labelBox = "input-module--label-box--zl4iF";
export var light = "input-module--light--oi-tu";
export var small = "input-module--small--u33FH";